import { api } from "~/utils/api"

export function useCoreIngestionLogs(
  orgId: string | undefined = undefined,
  shouldRefresh: boolean = true,
  sinceDays: number | undefined = orgId ? undefined : 7,
) {
  const { data: ingestionLogs } = api.updatedAt.getMetaLogs.useQuery(
    { orgId, sinceDays },
    {
      staleTime: 5000,
      refetchInterval: shouldRefresh
        ? (query) => (query.state.data?.some((log) => !log.endTime) ? 5000 : 20000)
        : 20000,
    },
  )
  return ingestionLogs
}
